import axios from "axios";
import "./ForgetPassword.css";
import { toast } from "react-toastify";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { validate } from "react-email-validator";
import { ThreeDots } from "react-loader-spinner";
import LoginImage from "../../images/login/lg-img.png";
import LoginImageMobile from "../../images/login/lg-img-mob.png";
import { getBrandLogo, getBrandLogoAlt } from "../../utils/brandLogo";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const abortControllerRef = useRef(null);


  const onSubmit = async (e) => {
    e.preventDefault();

    const normalizedEmail = email.trim();

    if (!validate(normalizedEmail)) {
        setHasError(true);
        return;
      }

    setLoading(true);

    const requestData = { email: normalizedEmail };

    try {
      // Cancel any previous in-flight request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const controller = new AbortController();
      abortControllerRef.current = controller;

      // Submit forgot-password request
      const res = await axios.post("/api/user/forgot-password", requestData, {
        signal: controller.signal,
      });
      const data = res?.data;

      if (data?.status === "success") {
        toast.success("Password reset mail has been sent to your email.", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
        navigate("/login");
      } else if (data?.status === "not_registered") {
        toast.error("Email not found. Please ensure it's registered or correct.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      } else {
        toast.error("Something went wrong while sending the reset email.", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
        global?.config?.activityLog?.(
          window.location.href,
          "Forgot Password",
          "Unexpected response while sending reset email"
        );
      }

    } catch (err) {
      console.error("Forgot password error:", err);
      if (axios.isCancel(err)) {
        return;
      }
      global?.config?.slackMessage?.(`Forgot password error: ${err.toString()}`);
      toast.error(err?.response?.data?.message || "An error occurred while sending the reset email.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);


  return (
    <>
      <div className="login-outer-forget">
        <div className="login-inner">
          <div className="top-logo-mobile">
            <img src={getBrandLogo()} alt={getBrandLogoAlt()} />
          </div>
          <div className="lg-lft">
            <img src={LoginImage} alt="desktop" className="desktop-lg-img" fetchpriority="high" />
            <img
              src={LoginImageMobile}
              alt="mobile"
              className="mobile-lg-img"
            />
          </div>
          <div className="lg-rgt">
            <div className="top-logo">
              <img src={getBrandLogo()} alt={getBrandLogoAlt()} />
            </div>
            <div className="login-form-sec">
              <form onSubmit={onSubmit}>
                <h3>Let’s reset your password!</h3>
                <p>
                  Please enter your email address.
                  <br />
                  You will receive a link to create a new password.
                </p>
                <div className="form-outer">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="email@gmail.com"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); if (hasError) setHasError(false); }}
                    className={hasError ? "input-error" : ""}
                  />
                </div>
                <div className="reset-button"></div>
                <button type="submit" disabled={loading}>
                  {loading ?
                    <div className="outter-load-table">
                      <ThreeDots
                        height="38"
                        width="40"
                        radius="9"
                        color="white"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    </div> : "Reset password"
                  }
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;